import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { TableActions } from '@ami/react/core';
import { InventoryItem } from '@ami/react/shared';
import { InventoryItemFilter } from '@ami/react/shared';
import { InventoryItemTable as Table } from '@ami/react/shared';
import { InventoryItemFilterComponent as FilterComponent } from '@ami/react/shared';
import { pagination } from '@ami/react/core';
import { Alert } from 'reactstrap';

class InventoryItemListPage extends Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    title: PropTypes.string,
  };

  state = {
    items: [],
    filter: new InventoryItemFilter(),
    loading: true,
  };

  search() {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    InventoryItem.search(this.state.filter, 0, true).then((items) =>
      this.setState({ items, loading: false })
    ).catch(() => {});
  }

  componentDidMount() {
    this.search();
  }

  handleOnView = (inventoryItemId) => {
    if (!inventoryItemId) {
      throw Error('Cannot edit Inventory Item. Invalid id specified.');
    }
    this.props.history.push(`/inventory-items/view/${inventoryItemId}`);
  };

  render() {
    return (
      <div>
        <div className="flextable">
          <h3 className="flextable-item flextable-primary page-title">
            {this.props.title}
          </h3>
        </div>
        <TableActions>
          <FilterComponent
            filter={this.state.filter}
            onChange={(x) =>
              this.setState({ filter: new InventoryItemFilter(x) })
            }
            onFilter={this.search}
          />
        </TableActions>
        <Table
          inventoryItems={this.state.items}
          onOpenEdit={this.handleOnView}
          loading={this.state.loading}
        />
        {this.state.items.length === pagination.pageSize && (
          <Alert className="mt-4 mb-3" color="primary">
            Too many results returned, please change your search criteria and
            try again
          </Alert>
        )}
      </div>
    );
  }
}

export default withRouter(InventoryItemListPage);
